import { Col, Result, Row } from 'antd';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useFeatureFlags } from '../feature-flag-react-lite';
import DOMPurify from 'dompurify';

dayjs.extend(utc);
dayjs.extend(timezone);

export const MaintenanceMessage = () => {
  const { GetFeatureFlagByName } = useFeatureFlags();
  const replaceTokens = (str: string, mapObj: any) => {
    const re = new RegExp(Object.keys(mapObj).join('|'), 'g');

    return str.replace(re, function (matched) {
      return mapObj[matched];
    });
  };

  const getMessage = () => {
    const maintenanceMessage = GetFeatureFlagByName('MAINTENANCE_MSG_SYSTEM_UI_APPLICANT_PORTAL');
    const maintenanceStartTimestamp = GetFeatureFlagByName("MAINTENANCE_START_TIMESTAMP_UI_APPLICANT_PORTAL");
    const maintenanceEndTimestamp = GetFeatureFlagByName("MAINTENANCE_END_TIMESTAMP_UI_APPLICANT_PORTAL");
    const startTimestampStr = dayjs(maintenanceStartTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const endTimestampStr = dayjs(maintenanceEndTimestamp)
      .tz('America/New_York')
      .format('h:mm a on dddd, MMMM DD, YYYY');
    const startDateStr = dayjs(maintenanceStartTimestamp).tz('America/New_York').format('MMMM DD');
    const endDateStr = dayjs(maintenanceEndTimestamp).tz('America/New_York').format('MMMM DD');
    const timeRangeStr = startDateStr === endDateStr ? startDateStr : `${startDateStr} - ${endDateStr}`;
    const mapObj = {
      '##startTimestampStr##': startTimestampStr,
      '##endTimestampStr##': endTimestampStr,
      '##timeRangeStr##': timeRangeStr
    };
    return replaceTokens(maintenanceMessage, mapObj);
  };

  return (
    <div data-testid="maintenance-message" style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
      <Row>
        <Col span={24}>
          <Result status="warning" title={''}></Result>
        </Col>
      </Row>
      <div style={{ textAlign: 'center' }}>
        <div
          style={{ maxWidth: '400px', display: 'inline-block' }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(getMessage() ?? '')
          }}
        ></div>
      </div>
    </div>
  );
};
